import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UiSettings, ZHelpers } from './../common';
import { LocalDataSource, ViewCell } from 'ng2-smart-table';
import { ZAuthService, SupplierService } from './../services';
import { UserModel, SupplierModel } from './../models';
import { SupplierOrderService } from './services/supplier-order.service';
import { SupplierOrderListModel } from './models/supplier-order-list.model';
import { SupplierOrderFilterModel } from './models/supplier-order-filter.model';
import { Observable } from 'rxjs/Observable';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';

@Component({
  selector: 'z-suppliers-barcodes',
  templateUrl: `./supplier-barcodes.template.html`
})
export class SuppliersBarcodesComponent implements OnInit {
  cellContent: any;
  cellValue: string;
  rawData: string;

  constructor(

    private route: ActivatedRoute,
    protected supplierOrderService: SupplierOrderService,
    private supplierService: SupplierService,
    protected zAuthService: ZAuthService) {
  }

  data: SupplierOrderListModel[];
  selectedItem: SupplierOrderListModel;
  source: LocalDataSource;
  user: UserModel;
  canChangeSupplier: boolean = false;


  supplierItem: SupplierModel = null;
  supplierItems: NgOption[] = [];
  supplierTypeahead = new EventEmitter<any>();

  orderStatuses: Array<any> = [{ label: 'All' },
  { label: 'Arrived' }, { label: 'Closed' }, { label: 'Cancelled' }, { label: 'Confirmed' },
  { label: 'Planned' }, { label: 'Received' }, { label: 'Released' }];
  isFiltered = false;
  filter: SupplierOrderFilterModel = new SupplierOrderFilterModel(null, null, this.orderStatuses[0], null);

  private columns = {
    orderNo: { title: 'Order No', filter: true },
    date: { title: 'Date', valuePrepareFunction: ZHelpers.SmartTable.dateTimeFormatter },
    status: {
      title: 'Status',
      type: 'html',
      valuePrepareFunction: (cell, row) => {
        return cell === 'Confirmed' ? `<span class="label label-sm label-warning md-shadow-z-1 ">${cell}</span>`
          : cell === 'Closed' ? `<span class="label label-sm label-primary md-shadow-z-1 ">${cell}</span>`
            : cell === 'Arrived' ? `<span class="label label-sm label-success md-shadow-z-1 ">${cell}</span>`
              : cell === 'Released' ? `<span class="label label-sm label-danger md-shadow-z-1 ">${cell}</span>`
                : cell === 'Received' ? `<span class="label label-sm label-info md-shadow-z-1 ">${cell}</span>`
                  : `<span class="label label-sm label-default md-shadow-z-1 ">${cell}</span>`
      }
    }
  };

  public settings: any = {
    ...UiSettings.defaultSmartTableSettings, columns: this.columns,
    edit: {
      editButtonContent: '<div class="btn btn-xs btn-primary btn-rectangle">View</div>',
    }
  };

  ngOnInit() {
    // this.source = new LocalDataSource();
    // this.canChangeSupplier = true;
    // this.loadData(this.filter);
    // this.settings.columns = {//add extra column in case of admin
    //   orderNo: this.columns.orderNo,
    //   contract: { title: 'Contract', filter: true },
    //   date: this.columns.date,
    //   status: this.columns.status,
    // };

    this.zAuthService.getCurrentUser()
      .subscribe(user => {
        this.user = user;
        this.source = new LocalDataSource();
        this.canChangeSupplier = this.zAuthService.isUserAdmin(user);

        if (this.canChangeSupplier) {
          this.setupAdminUserData();
        } else {
          this.setupRegularUserData();
        }
      });
  }

  private setupAdminUserData() {
    //add extra column in case of admin
    this.settings.columns = {
      orderNo: this.columns.orderNo,
      contract: { title: 'Contract', filter: true },
      date: this.columns.date,
      status: this.columns.status,
    };

    this.supplierTypeahead
      .distinctUntilChanged()
      .debounceTime(300)
      .switchMap(term => {
        if (term && term.length > 2) {
          return this.supplierService.getSuppliersByTerm(term);
        }
        return Observable.of([]);
      })
      .subscribe(items => {
        this.supplierItems = items;
      }, (err) => {
        console.log(err);
        this.supplierItems = [];
      });
  }

  private setupRegularUserData() {
    this.supplierService.getSupplierById(this.user.companyId).subscribe(supplier => {
      this.filter.supplier = supplier;
      this.isFiltered = true;
      this.loadData(this.filter);
    });
  }

  loadData(filter: SupplierOrderFilterModel) {
    this.supplierItem = filter.supplier;
    // ZHelpers.SmartTable.setData(this.source, [{
    //   orderNo: "123",
    //   date: new Date(),
    //   status: "Received"
    // }]);
    // this.selectedItem = null;
    this.supplierOrderService.getOrders(filter).subscribe((data) => {
      ZHelpers.SmartTable.setData(this.source, data);
      this.selectedItem = null;
    });
  }

  onItemClick(e) {
    this.selectedItem = e.data;
  }

  onCloseClick() {
    this.selectedItem = null;
  }

  onSubmitFilter() {
    this.isFiltered = true;
    this.selectedItem = null;
    this.source.load([]);
    this.source.empty();
    this.loadData(this.filter);
  }

}



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/supplier-barcodes.component.ts